import * as Sentry from '@sentry/browser';

if (process.env.REACT_APP_ENV !== "dev" && process.env.REACT_APP_ENV !== "test") {
  Sentry.init({
    dsn: "https://a2c40a55123f4ea6a2627de7a244a258@o439519.ingest.sentry.io/5457551",
    environment: process.env.REACT_APP_ENV
  });
}


// WEBPACK FOOTER //
// ./src/share/config/sentry.ts